import { Action, createReducer, on } from '@ngrx/store';
import {
  clearQRScanDataAction,
  getCompanyConfigAction,
  getCompanyConfigErrorAction,
  getCompanyConfigSuccessAction,
  setCompanyConfigIndexAction,
  setIsContrastColor,
  setIsAnonymousAction,
  setOrderFromSiteAction,
  setSiteIDAction,
} from './company-config.actions';
import { CompanyConfigState } from './company-config.state';
// import { CompanyConfigType } from '../enum';

const initialState = new CompanyConfigState();

const reducer = createReducer(
  initialState,
  on(getCompanyConfigAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getCompanyConfigSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.companyConfig = payload;
    return newState;
  }),
  on(getCompanyConfigErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(setCompanyConfigIndexAction, (state, { companyConfigIndex }) => {
    const newState = { ...state };
    newState.companyConfigIndex = companyConfigIndex;
    newState.isLoading = false;
    // if (companyConfigIndex[CompanyConfigType.AnonymousBrowsing]) {
    //   newState.isAnonymousBrowsing = companyConfigIndex[CompanyConfigType.AnonymousBrowsing];
    // }
    return newState;
  }),
  on(setSiteIDAction, (state, { siteId }) => {
    const newState = { ...state };
    newState.siteId = siteId;
    return newState;
  }),
  on(setOrderFromSiteAction, (state, { orderFromSite }) => {
    const newState = { ...state };
    newState.orderFromSite = orderFromSite;
    return newState;
  }),
  on(clearQRScanDataAction, (state) => {
    const newState = { ...state };
    newState.orderFromSite = null;
    newState.siteId = null;
    return newState;
  }),
  on(setIsAnonymousAction, (state, { isAnonymous }) => {
    const newState = { ...state };
    newState.isAnonymousBrowsing = isAnonymous;
    return newState;
  }),
  on(setIsContrastColor, (state, { isContrastColor }) => {
    const newState = { ...state };
    newState.isContrastColor = isContrastColor;
    newState.isLoading = false;
    return newState;
  })
);

export function CompanyConfigReducer(state: CompanyConfigState | null, action: Action) {
  return reducer(state, action);
}
